
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate API call
    setTimeout(() => {
      setSubmitted(true);
    }, 1000);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="bg-white p-8 rounded-3xl shadow-xl w-full max-w-md border border-slate-100">
        <div className="text-center mb-8">
          <span className="text-4xl mb-4 block">🔐</span>
          <h1 className="text-2xl font-bold text-indigo-900 brand-font">Forgot Password?</h1>
          <p className="text-slate-500">No worries, we'll send you reset instructions.</p>
        </div>

        {submitted ? (
          <div className="text-center">
            <div className="bg-green-50 text-green-700 p-4 rounded-xl mb-6">
              <i className="fas fa-check-circle text-2xl mb-2 block"></i>
              <p className="font-bold">Check your email!</p>
              <p className="text-sm">We've sent a reset link to {email}</p>
            </div>
            <Link to="/login">
                <Button className="w-full justify-center">Back to Login</Button>
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-bold text-slate-700 mb-1">Email</label>
              <input 
                type="email" 
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border-2 border-slate-200 focus:border-brand-blue outline-none"
                placeholder="Enter your email"
              />
            </div>
            <Button type="submit" className="w-full justify-center py-3">Send Reset Link</Button>
          </form>
        )}

        {!submitted && (
            <div className="mt-6 text-center text-sm">
                <Link to="/login" className="text-slate-400 hover:text-slate-600">
                    <i className="fas fa-arrow-left mr-1"></i> Back to Login
                </Link>
            </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
